module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebarg"
  }, [_c('p', {
    staticClass: "imagec",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "15",
      "src": "images/rstar.jpg",
      "width": "15"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introduction"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("1:")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("COMPOSTING = STEWARDSHIP")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("2:")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("PLANNING = VISION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("3:")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("TILLING = INITIATIVE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("4:")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("SOWING = FAITH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("5:")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("GROWING = PATIENCE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("6:")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("HEALING = COMPASSION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("7:")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("REAPING = GRATITUDE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("8:")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("SHARING = GENEROSITY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("9:")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("SUSTAINING = PERSEVERANCE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/resources#resources",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("RESOURCES: FARMER D’S TOOL CHEST")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/app01#app01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("INDEX OF SEARCHABLE TERMS")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "image-b"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/f0006-01.jpg",
      "width": "438"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0